export default __webpack_public_path__ + "static/media/group-13.1abaaaf0.png";